import { RequestQueryOptions } from '@approvalmax/data';
import { useLazyGet } from 'shared/data/api';

import { reportsApiPaths } from '../paths';
import { GetReportStatus } from './useLazyGetReportStatus.types';

export const useLazyGetReportStatus = (queryOptions?: RequestQueryOptions<GetReportStatus>) =>
    useLazyGet<GetReportStatus>(reportsApiPaths.reportStatus, {
        queryOptions,
        apiSource: 'wallets',
        apiVersion: 'v1',
    });
